import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { getFilesFromInputChangeEvent } from '../../utils/input-utils';
import { Icon } from '../icon';
const b = bemClassBuilder('v-file-dropzone');
export const FileDropzone = observer(props => {
    const { fileType, multiple, activeDragIconName, inputRef, onFilesChanged, children } = props;
    const handleDrop = useCallback((acceptedFiles) => onFilesChanged(acceptedFiles), [onFilesChanged]);
    const handleFilesChanged = (event) => {
        const files = getFilesFromInputChangeEvent(event);
        onFilesChanged(files);
        event.target.value = ''; // to allow for re-selection of the same file to trigger onChange event.
    };
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop: handleDrop });
    const rootProps = getRootProps({
        onClick: e => e.stopPropagation()
    });
    return (_jsxs("div", Object.assign({ className: b.block() }, rootProps, { children: [_jsx("input", Object.assign({}, getInputProps(), { ref: inputRef, type: "file", accept: fileType, multiple: multiple, onChange: handleFilesChanged })), children, _jsx("div", Object.assign({ className: b.element('overlay', { show: isDragActive }) }, { children: _jsx("div", Object.assign({ className: b.element('overlay-icon') }, { children: _jsx(Icon, { name: activeDragIconName }) })) }))] })));
});
FileDropzone.displayName = 'FileDropzone';
